import { AccountManager } from "../../../workers/AccountManager";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * @author kmy
 * @date 2025-03-28
 * @remark 간편 로그인(카카오)
 * @returns 
*/


function FacebookLogin() {
    const code = new URL(window.location.href).searchParams.get("code");
    const state = new URL(window.location.href).searchParams.get("state");
    useEffect(() => {
        portalLogin();
    }, [])
    
    const portalLogin = async() => {
        let param = {
            process: 'login',
            platform: 'facebook',
            code : code,
            state : state
        };

        const accountManager = AccountManager.getInstance();
        const json = accountManager.portalLoginCallback(param);
    }

    return (
        <div>
                    
        </div>
    );
    }

export default FacebookLogin;